module.exports = __webpack_public_path__ + "static/media/banner1.08e16bc7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/aalbers/images/banner1.jpg
// module id = 570
// module chunks = 0